import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/axios'
import { API_ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/stores/useAuthStore'

export interface Material {
    id: number
    name: string
    slug: string
    description: string
    is_active: boolean
    sort_order: number
}

const KEYS = {
    all: ['materials'] as const,
    list: () => [...KEYS.all, 'list'] as const,
}

export function useMaterials() {
    const { isLogged } = useAuthStore()
    return useQuery({
        queryKey: KEYS.list(),
        queryFn: async () => {
            const { data } = await api.get<{ results: Material[] } | Material[]>(API_ROUTES.materials)
            return Array.isArray(data) ? data : data.results
        },
        enabled: isLogged,
        staleTime: 5 * 60 * 1000,
    })
}
